/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ facts: NonNullable<unknown> }} Exercise_Personal_Strength_MissingInputs */

const en_us2_exercise_personal_strength_missing = /** @type {(inputs: Exercise_Personal_Strength_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`To see your level, add to your profile: ${i?.facts}.`)
};

const pt_br2_exercise_personal_strength_missing = /** @type {(inputs: Exercise_Personal_Strength_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Para ver seu nível, complete no perfil: ${i?.facts}.`)
};

const es_419_exercise_personal_strength_missing = /** @type {(inputs: Exercise_Personal_Strength_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Para ver tu nivel, completa en tu perfil: ${i?.facts}.`)
};

const pt_pt2_exercise_personal_strength_missing = /** @type {(inputs: Exercise_Personal_Strength_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Para veres o teu nível, completa no perfil: ${i?.facts}.`)
};

const fr_fr2_exercise_personal_strength_missing = /** @type {(inputs: Exercise_Personal_Strength_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pour voir ton niveau, complète ton profil : ${i?.facts}.`)
};

const de_de2_exercise_personal_strength_missing = /** @type {(inputs: Exercise_Personal_Strength_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Um dein Niveau zu sehen, ergänze in deinem Profil: ${i?.facts}.`)
};

const it_it2_exercise_personal_strength_missing = /** @type {(inputs: Exercise_Personal_Strength_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Per vedere il tuo livello, aggiungi al profilo: ${i?.facts}.`)
};

/**
* | output |
* | --- |
* | "To see your level, add to your profile: {facts}." |
*
* @param {Exercise_Personal_Strength_MissingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_strength_missing = /** @type {((inputs: Exercise_Personal_Strength_MissingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Strength_MissingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_strength_missing(inputs)
	if (locale === "es-419") return es_419_exercise_personal_strength_missing(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_strength_missing(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_strength_missing(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_strength_missing(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_strength_missing(inputs)
	return en_us2_exercise_personal_strength_missing(inputs)
});
export { exercise_personal_strength_missing as "exercise-personal.strength_missing" }